import { RootState } from "@/utils/store";

type V0State = Pick<RootState, "teams" | "options"> & {
  options: {
    tableViews: {
      videosTable: {
        "Script Topics": boolean;
        "Thumb Topics": boolean;
        "Video Type": boolean;
      };
    };
  };
};

const v0 = (state: V0State) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        topVideosTable: {
          "Total views": true,
          V7: true,
          V30: true,
          VPH7: true,
          VPH30: true,
          "V7 Index": true,
          "V30 Index": true,
          Published: false,
          Revenue: false,
          "Script Topics": false,
          "Thumb Topics": false,
          "Title Topics": false,
          "Video Type": false,
        },
      },
    },
  };
};

export default v0;
